import axios from '@/axios.js'

export default {
    getUsers: async (params) => {
        try {
            const response = await axios.adminapi.get(`v4/users`,{
                params: params
            })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },

    getUser: async (userUuid) => {
        try {
            const response = await axios.adminapi.get(`v4/users/${userUuid}`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },

    createUser: async (userUuid, data) => {
        const response = await axios.adminapi.post(`v4/users/${userUuid}`, data)
        return response.data
    },

    editUser: async (userUuid, data) => {
        try {
            const response = await axios.adminapi.patch(`v4/users/${userUuid}`, data)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },

    deleteUser: async (userUuid) => {
        try {
            const response = await axios.adminapi.delete(`v4/users/${userUuid}?force=1`)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },

    sendEmail: async (userUuid, template) => {
        try {
            const response = await axios.adminapi.post(`v4/users/${userUuid}/email`, {template})
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    }
}
